import './profileStep3.scss';
import { getViewNameByStatus } from 'actions/getViewNameByStatus';
import OkModalOnboarding from 'components/commons/OkModalOnboarding/OkModalOnboarding';
import IdentificationMethod from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/IdentificationMethod';
import {
    checkVideoPermission,
    getCurrentDate,
    isTimeAvailableForVideoContent,
    isValidBrowser,
} from 'components/newAccountSteps/profileSteps/profileStep3/videocall/videocallHelper';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { ERROR_EN_IDENTIFICACION } from 'constants/analyticsErrors';
import {
    ONLINE_IBAN,
    ROBO_IBAN,
    ROBO_TRANSFER,
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_IBAN,
    TC_VIDEOCALL,
    TC_VIDEOS,
    TC_VIDEOSELFIE,
    VIDEO_CALL_CHROME_IOS_FLAG,
    VIDEO_SELFIE_CHROME_IOS_FLAG,
    VIDEOCALLS_IN_1_BOX,
    VIDEOSELFIE_CAPTURE,
} from 'constants/featureFlagging';
import {
    COURIER,
    IBAN,
    IBAN_INVESTMENT_TYPES,
    TRANSFER_CERTIFICATE,
    TRANSFER_INVESTMENT_TYPES,
    VIDEO,
    VIDEO_CALL,
    VIDEO_SELFIE,
} from 'constants/identityMethod';
import { ASNEF_ERROR, FAILED_STATUS, SUCCESS_STATUS, WAITING_STATUS } from 'constants/pollingConstants';
import { IDENTIFIED_ROBO, PRE_DOCUMENTATION } from 'constants/statusProcess';
import { ROBO } from 'constants/userProfile';
import { IDENTITY_CONST, IDENTITY_VIDEOS_RECORD_TAG, PATH_IDENTITY } from 'constants/uTagConstants/paths';
import {
    EVENT_ONBOARDING,
    IBAN_MODAL_VALIDATION,
    IBAN_MODAL_VALIDATION_STATUS,
} from 'constants/uTagConstants/RAConstants';
import { ABORTED, COMPLETED, DEFINITE_KO } from 'constants/video/status';
import { i18n } from 'core/i18n';
import cryptoJS from 'crypto-js';
import { useNetworkMeter } from 'hooks/useNetworkMeter';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { get, post } from 'utilities/APIRequestHelper';
import { getAliasesDocumentType } from 'utilities/multiLanguageHelper';
import CookiesStorage from 'utilities/storage';
import { errorTag, recordEventCustomOnly, recordEventStepSuccess, recordIdentityEvent } from 'utilities/uTagging';
import { getStatusCode } from 'utilities/video/status/getStatusCode';
import OnlineValidationModal from '../../newIdentifyMethods/Iban/OnlineValidationModal';
import { TransferIdentificationModal } from './modals/TransferIdentificationModal/TransferIdentificationModal';
import { isAndroid } from 'utilities/browser';
import { ReidentificationModal } from './modals/ReidentificationModal/ReidentificationModal';
import {
    doTagReidentificationModalCancel,
    doTagReidentificationModalContinue,
} from './modals/ReidentificationModal/tagging';
import {
    doTagTransferIdentificationModalCancel,
    doTagTransferIdentificationModalContinue,
} from './modals/TransferIdentificationModal/tagging';
import { getIsXpressIdSupported } from 'utilities/video/xpressIdCompatibility';

const { formatText } = i18n;

const NETWORK_METER_DEFAULT_CONFIG = {
    thresholdUnit: 'megabyte',
    measureOnLoad: false,
};

export const ProfileStep3 = ({
    identificationByCountry,
    userProfile,
    setServerDate,
    options,
    hidePreLoader,
    change,
    setValidity,
    resetValidity,
    callCenterKO,
    startPolling,
    clientDefiniteKO,
    iban,
    showModalCancel,
    flags,
    changeCurrentStep,
    enableFinishedAndNextStep,
    finalizeStep,
    resetIdentityIban,
    immStepsState,
    stopPolling,
    identifyIban,
    identifyTransfer,
    identifyVideo,
    getServerDate,
    videoAvailability,
    tagByCountry,
    setIbanError,
    storage,
    isIbanActive,
    goToErrorsView,
}) => {
    const getIdentificationData = () => storage.get('identification') || {};
    const identification = getIdentificationData();
    const INITIAL_METHOD = identification?.currentTab ?? 0;
    const isVeridasVideoSelfieActive = userProfile.videoSelected === VIDEO_SELFIE && flags.get(VIDEOSELFIE_CAPTURE);
    const isCheckPermissionsActive = !isVeridasVideoSelfieActive || isAndroid();

    const [state, setState] = useState({
        selectedIdent: identificationByCountry()[INITIAL_METHOD],
        selectedIdentIndex: INITIAL_METHOD,
        dateInterval: null,
        failedIbanOnlineAttempt: false,
        isLastIbanOnlineRequest: false,
        bankName: '',
        clickedContinue: false,
    });

    const [showIbanFailPopUP, setShowIbanFailPopUP] = useState(false);
    const [showModalTransfer, setShowModalTransfer] = useState(false);
    const [showReidentificationModal, setShowReidentificationModal] = useState(userProfile.identifiedSuccessfully);
    const [modalData, setModalData] = useState({
        showModal: false,
        activeModal: '',
    });

    const { makeMeasure, networkSpeed } = useNetworkMeter(NETWORK_METER_DEFAULT_CONFIG);

    useEffect(() => {
        const measureTimer = setTimeout(() => {
            makeMeasure();
        }, 3000);

        if (!identification?.currentTab) {
            storage.set('identification', { ...identification, currentTab: 0 });
        }

        return () => {
            clearTimeout(measureTimer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setNewDate = () => {
        const serverDate = new Date(options?.get('serverDate'));
        serverDate.setMinutes(serverDate.getMinutes() + 1);
        const formattedDate = serverDate
            .toLocaleString('es', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
            })
            .replace(',', '')
            .replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');
        setServerDate(formattedDate);
    };

    const setDateInterval = () => {
        if (!options?.get('serverDate')) return;

        const dateInterval = setInterval(setNewDate, 60000);
        setState({ ...state, dateInterval });
    };

    const ibanPollValidationCallback = response => {
        const {
            ok,
            body: { status },
        } = response;

        if (ok && status !== WAITING_STATUS) return false;

        return true;
    };

    const handleModal = (open, activeModal) => {
        const { showModal } = modalData;
        const delay = open && showModal ? 200 : 0;
        if (open && showModal) {
            setModalData({ ...modalData, showModal: false });
        }
        setTimeout(() => setModalData({ ...modalData, activeModal, showModal: open }), delay);
    };

    const handleFinishIbanPolling = (response, stats) => {
        const { ok } = stats;
        const { investmentType } = userProfile;

        const {
            body: { status, onboardingStatus },
        } = response;

        hidePreLoader();
        if (ok) {
            switch (status) {
                case SUCCESS_STATUS:
                    handleModal(true, SUCCESS_STATUS);
                    change('userProfile.status', onboardingStatus);
                    recordIdentityEvent(
                        PATH_IDENTITY,
                        `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.SUCCESS}`,
                        `vista`
                    );
                    recordEventStepSuccess(investmentType, 'identidad/iban', 'identificacion iban', {
                        event_name: 'event_success',
                        action: 'success',
                        format: 'steps',
                        component: 'funnel',
                        element: 'identity',
                    });
                    break;
                case FAILED_STATUS:
                    resetIdentityIban();
                    handleModal(true, FAILED_STATUS);
                    recordIdentityEvent(
                        PATH_IDENTITY,
                        `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.FAILED}`,
                        'vista'
                    );
                    setState({
                        ...state,
                        selectedIdent: identificationByCountry()[INITIAL_METHOD],
                        identityMethod: identificationByCountry()[INITIAL_METHOD],
                        selectedIdentIndex: INITIAL_METHOD,
                        failedIbanOnlineAttempt: true,
                    });
                    break;
                case WAITING_STATUS:
                    recordIdentityEvent(
                        PATH_IDENTITY,
                        `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.CHECKING}`,
                        `vista`
                    );
                    break;
                case ASNEF_ERROR:
                    callCenterKO();
                    change('userProfile.identityStatus', ABORTED);
                    break;
                default:
                    break;
            }
        }
    };

    const startOnlineIbanPolling = () => {
        const { accessToken } = userProfile;

        handleModal(true, WAITING_STATUS);
        recordIdentityEvent(
            PATH_IDENTITY,
            `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.CHECKING}`,
            'vista'
        );

        startPolling({
            asyncFetch: requestQuery => {
                const payload = {
                    header: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    ...requestQuery,
                };

                if (requestQuery.query.isLast) setState({ ...state, isLastIbanOnlineRequest: true });

                return post('ibanIdentificationOnlineStatus', payload);
            },
            callback: ibanPollValidationCallback,
            callbackEnd: handleFinishIbanPolling,
            delay: 1,
            ttl: 240,
            retryOnFailure: true,
            retryAfter: 2,
            stopAfterRetries: 2,
            maxRequests: 12,
        });
    };

    const onAcceptIbanValidationSuccessModal = param => {
        const { investmentType } = userProfile;
        investmentType === ROBO ? change('userProfile.identified-robo', true) : change('userProfile.identified', true);
        change('userProfile.identityMethod', IBAN);
        recordIdentityEvent(PATH_IDENTITY, `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.SUCCESS}`, param);
        handleModal(false);
    };

    const handleIbanValidationFailedModal = () => {
        handleModal(false);
        setState({ ...state, isLastIbanOnlineRequest: false });
    };

    const renderBodyModal = (activeModal, userProfile) => {
        const { isLastIbanOnlineRequest } = state;
        switch (activeModal) {
            case FAILED_STATUS:
                return {
                    content: (
                        <OnlineValidationModal
                            userProfile={userProfile}
                            icon={<span className="icons icons--icon-warning" />}
                            body={
                                isLastIbanOnlineRequest
                                    ? formatText('ibanOnline-timeOutModalBody')
                                    : formatText('ibanOnline-errorModalBody')
                            }
                            head={
                                isLastIbanOnlineRequest
                                    ? formatText('ibanOnline-timeOutModalHead')
                                    : formatText('ibanOnline-errorModalHead')
                            }
                            buttonText={
                                isLastIbanOnlineRequest
                                    ? formatText('ibanOnline-timeOutModalButtonText')
                                    : formatText('ibanOnline-errorUnderstood')
                            }
                            withButton={true}
                            onAccept={() => {
                                recordIdentityEvent(
                                    PATH_IDENTITY,
                                    `${IBAN_MODAL_VALIDATION}/${IBAN_MODAL_VALIDATION_STATUS.FAILED}`,
                                    'volver a identificarme | cerrar'
                                );
                                handleIbanValidationFailedModal();
                            }}
                        />
                    ),
                    onClose: () => handleIbanValidationFailedModal(),
                    displayHeaderCloseIcon: false,
                };
            case SUCCESS_STATUS:
                return {
                    content: (
                        <OnlineValidationModal
                            userProfile={userProfile}
                            icon={<span className="icons icons--icon-success-circle" />}
                            head={formatText('ibanOnline-successModalHead')}
                            buttonText={formatText('ibanOnline-successValidationContinue')}
                            withButton={true}
                            onAccept={() => onAcceptIbanValidationSuccessModal('continuar')}
                        />
                    ),
                    onClose: () => onAcceptIbanValidationSuccessModal('cerrar'),
                    displayHeaderCloseIcon: false,
                };
            default:
                return {
                    content: (
                        <OnlineValidationModal
                            userProfile={userProfile}
                            icon={<span className="icons icons--icon-waiting-key-gif" />}
                            body={formatText('ibanOnline-waitingModalBody')}
                            head={formatText('ibanOnline-waitingModalHead')}
                            withButton={false}
                        />
                    ),
                    onClose: () => handleModal(false),
                    displayHeaderCloseIcon: false,
                };
        }
    };

    const renderModal = userProfile => {
        const { activeModal, showModal } = modalData;
        const { content, onClose, displayHeaderCloseIcon } = renderBodyModal(activeModal, userProfile);

        return (
            <OkModalOnboarding
                headerCloseIcon={displayHeaderCloseIcon}
                onClose={onClose}
                modalIsOpen={showModal}
                className="identify-modal__modal-content"
            >
                {content}
            </OkModalOnboarding>
        );
    };

    const handleFinishVideoPolling = (response, stats) => {
        const { investmentType } = userProfile;

        if (!response) return;

        const { ok, error } = stats;

        if (ok) {
            const {
                body: { status, onboardingStatus, method },
            } = response;
            const statusCode = getStatusCode(status, method, userProfile);
            statusCode === DEFINITE_KO || (statusCode === ABORTED && clientDefiniteKO());

            investmentType === ROBO
                ? change('userProfile.identified-robo', statusCode === COMPLETED)
                : change('userProfile.identified', statusCode === COMPLETED);

            change('userProfile.identityStatus', statusCode);
            change('userProfile.status', onboardingStatus);
        }

        if (error) {
            const { body: bodyError, statusCode } = response;
            bodyError && errorTag(bodyError, PATH_IDENTITY, ERROR_EN_IDENTIFICACION, statusCode);
            goToErrorsView({ errorCode: statusCode, errorMessage: ERROR_EN_IDENTIFICACION });
        }
    };

    const startVideoPolling = () => {
        startPolling({
            asyncFetch: () => get('getClientIdentificationStatus'),
            callback: response => (response ? !response.ok : false),
            callbackEnd: handleFinishVideoPolling,
            delay: 1,
            ttl: 240,
            retryOnFailure: true,
            retryAfter: 2,
            stopAfterRetries: 2,
        });
    };

    const disabledByIban = () => {
        const ibanVerified = iban.get('verified');
        const ibanError = iban.get('error');

        return !ibanVerified || !!ibanError;
    };

    const handleExitModal = () => {
        recordEventCustomOnly({
            action: 'exit',
            format: 'link',
            component: 'form',
            element: 'exit',
            eventCategory: '/onboarding/step6/identitySelfieByDefaultWithOption',
            eventAction: 'clickLink',
            eventLabel: 'exitLink',
        });

        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: 'salir',
        });

        showModalCancel();
    };

    const isVideoContinueDisabled = () => {
        const videoChromeFlag =
            userProfile.videoSelected === VIDEO_CALL
                ? flags.get(VIDEO_CALL_CHROME_IOS_FLAG)
                : flags.get(VIDEO_SELFIE_CHROME_IOS_FLAG);
        const { agreeVideoCallClauseCheck } = userProfile;
        const isVideoIdentificationSupported = isVeridasVideoSelfieActive
            ? getIsXpressIdSupported()
            : isValidBrowser(videoChromeFlag);

        return !agreeVideoCallClauseCheck || !isVideoIdentificationSupported;
    };

    const disableContinueButton = () => {
        const { selectedIdent } = state;
        const { ibanTermsClause } = userProfile;

        switch (selectedIdent) {
            case COURIER:
            case VIDEO:
            case VIDEO_SELFIE:
            case VIDEO_CALL:
            case TC_VIDEOS:
            case TC_VIDEOSELFIE:
            case TC_VIDEOCALL:
            case ROBO_VIDEOS:
            case ROBO_VIDEOCALL:
            case ROBO_VIDEOSELFIE:
            case VIDEOCALLS_IN_1_BOX:
                return isVideoContinueDisabled();
            case ROBO_TRANSFER:
            case TRANSFER_CERTIFICATE:
                return false;
            case TC_IBAN:
            case ROBO_IBAN:
            case IBAN:
                if (flags.get(ONLINE_IBAN) && !ibanTermsClause) return true;

                return disabledByIban();
        }
    };

    const goNextStepByMethod = currentIndex => {
        finalizeStep({ index: currentIndex, finished: true });
        enableFinishedAndNextStep();
        const viewName = getViewNameByStatus(userProfile.status);
        changeCurrentStep(
            viewName
                ? {
                      viewName,
                  }
                : { index: currentIndex + 1 }
        );
    };

    const onClickOption = selectedIdent => {
        if (selectedIdent === state.selectedIdent) return;

        const selectedIdentIndex = identificationByCountry().indexOf(selectedIdent);

        const identification = getIdentificationData();
        storage.set('identification', { ...identification, currentTab: selectedIdentIndex });

        setState({ ...state, selectedIdent, selectedIdentIndex });
        change('userProfile.videoCallClause', false);
        change('userProfile.agreeVideoCallClauseCheck', false);
        const methodToReset = [TC_IBAN, ROBO_IBAN, IBAN];
        const haveToResetIban = methodToReset.some(method => method === selectedIdent);
        const ibanVerified = iban.get('verified');
        resetValidity('userProfile.ibanTermsClause');
        if (haveToResetIban && !ibanVerified) {
            resetIdentityIban();
        } else {
            change('userProfile.ibanTermsClause', undefined);
        }
    };
    const gotoNextStep = () => {
        const { identified, identityMethod } = userProfile;

        if (identified || userProfile[IDENTIFIED_ROBO]) {
            const currentIndex = immStepsState.get('currentStep');
            userProfile[IDENTIFIED_ROBO] && change('userProfile.status', PRE_DOCUMENTATION);
            identityMethod === TRANSFER_CERTIFICATE && goNextStepByMethod(currentIndex);
            identityMethod === IBAN && goNextStepByMethod(currentIndex);
        }
    };

    const continueIban = () => {
        const { ibanTermsClause } = userProfile;
        const identityIban = iban.get('iban');

        !identityIban && setIbanError('validation-ibanNull');
        !ibanTermsClause && setValidity('userProfile.ibanTermsClause', { required: false });

        if (!identityIban || !ibanTermsClause) {
            return;
        }

        const ibanVerified = iban.get('verified');
        const ibanError = iban.get('error');

        if (ibanVerified && !ibanError) {
            const ibanOnline = flags.get(ONLINE_IBAN);
            const formattedIban = identityIban.includes(' ')
                ? identityIban
                : identityIban
                      .trim()
                      .match(/.{1,4}/g)
                      .join(' ');

            ibanOnline && stopPolling();
            identifyIban(formattedIban, formattedIban, userProfile, ibanOnline, {
                startOnlineIbanPolling,
                stopPolling,
            });
            storage.remove('identification');
        }
    };

    const continueTransfer = () => {
        setShowModalTransfer(prevState => !prevState);
    };

    const continueModalTransfer = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        setShowModalTransfer(false);
        identifyTransfer(userProfile, docNumberEncrypted);
        storage.remove('identification');
    };

    const isVideoMethodSelected = () => {
        const { selectedIdent } = state;
        const videoTypes = [
            VIDEO_SELFIE,
            VIDEO_CALL,
            TC_VIDEOS,
            TC_VIDEOSELFIE,
            TC_VIDEOCALL,
            ROBO_VIDEOS,
            ROBO_VIDEOCALL,
            ROBO_VIDEOSELFIE,
            VIDEOCALLS_IN_1_BOX,
        ];

        return videoTypes.some(type => type === selectedIdent);
    };

    const continueVideo = () => {
        const { videoSelected, grantedPermission } = userProfile;

        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clic',
            etiquetaEvento: formatText(
                userProfile.videoSelected === VIDEO_CALL ? 'button-videoCallButton' : 'button-videoSelfieButton'
            ),
        });

        recordEventCustomOnly({
            categoriaEvento: 'onboarding/test-internet',
            accionEvento: 'Mbps/download',
            etiquetaEvento: networkSpeed,
        });

        if (isVideoContinueDisabled()) {
            !userProfile.agreeVideoCallClauseCheck &&
                setValidity('userProfile.agreeVideoCallClauseCheck', { required: false });

            return;
        }

        isCheckPermissionsActive &&
            checkVideoPermission({
                grantedPermission,
                changeFunction: change,
                videoSelected,
            });

        setState(prevState => ({ ...prevState, clickedContinue: true }));
    };

    useEffect(() => {
        const {
            investmentType,
            videoSelected,
            videoUrlSelected,
            acceptedText,
            grantedPermission,
            agreeVideoCallClauseCheck,
        } = userProfile;
        const isPermissionCheckDone = (isCheckPermissionsActive && grantedPermission) || !isCheckPermissionsActive;
        if (isPermissionCheckDone && agreeVideoCallClauseCheck && state.clickedContinue) {
            const date = getCurrentDate(options);
            recordIdentityEvent(
                EVENT_ONBOARDING,
                IDENTITY_CONST,
                `comenzar ${IDENTITY_VIDEOS_RECORD_TAG[videoSelected]}`
            );

            const language = CookiesStorage.cookies.get('language');
            identifyVideo({
                date,
                videoCallType: videoSelected,
                urlCallType: videoUrlSelected,
                language,
                investmentType,
                acceptedText,
            });
            setState(prevState => ({ ...prevState, clickedContinue: false }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfile.grantedPermission, userProfile.agreeVideoCallClauseCheck, state.clickedContinue]);

    const handleContinue = () => {
        const { selectedIdent } = state;
        const { investmentType } = userProfile;

        recordEventCustomOnly({
            action: 'continue',
            format: 'button',
            component: 'form',
            element: 'continue',
            eventCategory: '/onboarding/step6/identitySelfieByDefaultWithOption',
            eventAction: 'clickButton',
            eventLabel: 'continueButton',
        });

        selectedIdent === IBAN_INVESTMENT_TYPES[investmentType] && continueIban();
        selectedIdent === TRANSFER_INVESTMENT_TYPES[investmentType] && continueTransfer();
        isVideoMethodSelected() && continueVideo();
    };

    const handleShowIbanErrorModal = bankName => {
        resetIdentityIban();
        resetValidity('userProfile.ibanTermsClause');
        recordEventCustomOnly({
            categoriaEvento: 'onboarding',
            accionEvento: 'identidad/iban/modal-iban/no-disponible',
            etiquetaEvento: 'vista',
        });
        setShowIbanFailPopUP(true);
        setState({ ...state, bankName: bankName ? bankName : '' });
    };

    const handleCloseIbanErrorModal = closeTag => {
        setShowIbanFailPopUP(false);
        setState({ ...state, bankName: '' });
        closeTag &&
            recordEventCustomOnly({
                categoriaEvento: 'onboarding',
                accionEvento: 'identidad/iban/modal-iban/no-disponible',
                etiquetaEvento: 'cerrar',
            });
    };

    const handleIsTimeAvailableForVideoContent = videoSelected => {
        return isTimeAvailableForVideoContent({ options, videoSelected });
    };

    const getDocumentRequiredText = () => {
        const { passport, documentType } = userProfile;
        if (passport) {
            const passportText = formatText('identity-courierInfo4');

            return passportText && passportText.toLowerCase();
        }

        return getAliasesDocumentType(documentType);
    };

    const handleChangeTab = () => {
        resetValidity('userProfile.agreeVideoCallClauseCheck');
        resetValidity('userProfile.ibanTermsClause');
    };

    const getContinueButtonLabel = () => {
        const { videoSelected } = userProfile;

        const textsByType = {
            [VIDEO_CALL]: formatText('button-videoCallButton'),
            [VIDEO_SELFIE]: formatText('button-videoSelfieButton'),
        };

        return textsByType[videoSelected] || formatText('button-continue');
    };

    useEffect(() => {
        const { dateInterval } = state;

        if (userProfile.identified) {
            return () => {
                stopPolling();
                clearInterval(dateInterval);
            };
        }

        window.scrollTo(0, 0);
        getServerDate();
        startVideoPolling();
        setDateInterval();
        gotoNextStep();

        return () => {
            stopPolling();
            clearInterval(dateInterval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const { dateInterval } = state;
        const date = options?.get('serverDate');
        date && !dateInterval && setDateInterval();
        gotoNextStep();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.dateInterval, userProfile.identified, userProfile[IDENTIFIED_ROBO]]);

    const transferIdentificacionModalActions = {
        cancel: () => {
            setShowModalTransfer(false);
            doTagTransferIdentificationModalCancel();
        },
        continue: () => {
            continueModalTransfer();
            doTagTransferIdentificationModalContinue();
        },
    };

    const reidentificacionModalActions = {
        cancel: () => {
            setShowReidentificationModal(false);
            doTagReidentificationModalCancel();
        },
        continue: () => {
            setShowReidentificationModal(false);
            doTagReidentificationModalContinue();
        },
    };

    const { selectedIdent, selectedIdentIndex, bankName } = state;

    return (
        <div className="new-profile-step3">
            <div className="new-profile-step3__optionsbox">
                <TransferIdentificationModal
                    showModal={showModalTransfer}
                    handleCancel={transferIdentificacionModalActions.cancel}
                    handleContinue={transferIdentificacionModalActions.continue}
                />
                <ReidentificationModal
                    showModal={showReidentificationModal}
                    handleCancel={reidentificacionModalActions.cancel}
                    handleContinue={reidentificacionModalActions.continue}
                />
                <IdentificationMethod
                    identOrderByCountry={identificationByCountry()}
                    onChangeTab={handleChangeTab}
                    // eslint-disable-next-line no-undef
                    tagByCountry={tagByCountry[__ORIGIN_COUNTRY__]}
                    selectedIdent={selectedIdent}
                    selectedIdentIndex={selectedIdentIndex}
                    videoAvailability={videoAvailability}
                    handleCloseIbanErrorModal={handleCloseIbanErrorModal}
                    showIbanFailPopUP={showIbanFailPopUP}
                    handleShowIbanErrorModal={handleShowIbanErrorModal}
                    bankName={bankName}
                    documentRequiredText={getDocumentRequiredText()}
                    handleIsTimeAvailableForVideoContent={handleIsTimeAvailableForVideoContent}
                    storage={storage}
                    onClickOption={onClickOption}
                    isIbanActive={isIbanActive}
                />
            </div>
            <RoadmapNavigation
                stepFooter
                buttonPrevHidden={true}
                buttonContinueAction={handleContinue}
                buttonContinueFakeDisabled={disableContinueButton()}
                buttonCancelAction={handleExitModal}
                buttonContinueText={getContinueButtonLabel()}
                isButtonContinueLoading={userProfile.agreeVideoCallClauseCheck && userProfile.requestingPermissions}
                buttonContinueDisabled={userProfile.agreeVideoCallClauseCheck && userProfile.requestingPermissions}
            />
            {renderModal(userProfile)}
        </div>
    );
};

ProfileStep3.propTypes = {
    immStepsState: PropTypes.object,
    userProfile: PropTypes.object,
    identificationByCountry: PropTypes.func,
    setServerDate: PropTypes.func,
    options: PropTypes.object,
    hidePreLoader: PropTypes.func,
    change: PropTypes.func,
    changeCurrentStep: PropTypes.func,
    callCenterKO: PropTypes.func,
    startPolling: PropTypes.func,
    clientDefiniteKO: PropTypes.func,
    iban: PropTypes.object,
    showModalCancel: PropTypes.func,
    flags: PropTypes.object,
    enableFinishedAndNextStep: PropTypes.func,
    finalizeStep: PropTypes.func,
    resetIdentityIban: PropTypes.func,
    stopPolling: PropTypes.func,
    identifyIban: PropTypes.func,
    identifyTransfer: PropTypes.func,
    identifyVideo: PropTypes.func,
    getServerDate: PropTypes.func,
    tagByCountry: PropTypes.object,
    videoAvailability: PropTypes.object,
    setValidity: PropTypes.func,
    resetValidity: PropTypes.func,
    setIbanError: PropTypes.func,
    storage: PropTypes.object,
    isIbanActive: PropTypes.bool,
};
